<template scope="scope">
  <el-dialog title="环保奖励开通" :visible.sync="dialogMungBeanFormVisible">
      <el-form style="margin-left:20px;" ref="configForm" :model="configForm" label-width="160px">

             <el-radio-group v-model="configForm.isSendMungBean" @change="setMungBean()">
                <el-radio  :label="2">关闭权限</el-radio>
                <el-radio :label="1">开通权限</el-radio>

            </el-radio-group>
      </el-form>
    </el-dialog>

</template>

<script>

import BusinessModel from '@/framework/models/businessModel'

export default {
  name: 'set-mung-bean',
  data () {
    return {
      configForm: {
        isSendMungBean: 2,
        id: null
      },
      dialogMungBeanFormVisible: false
    }
  },
  methods: {
    showMungBean: function (data) {
      this.dialogMungBeanFormVisible = true
      this.configForm.isSendMungBean = data.isSendMungBean
      this.configForm.id = data.id
    },

    setMungBean: function () {
      let _this = this
      let param = { 'id': this.configForm.id, 'isSendMungBean': this.configForm.isSendMungBean }
      let listener = {
        success: function (dataInfo) {
          if (dataInfo.success) {
            _this.$message({
              message: '修改成功！',
              type: 'success'
            })
          } else {
            _this.$message({
              message: '修改失败！',
              type: 'error'
            })
          }
          _this.$emit('onSuccess', null)
        }
      }
      BusinessModel.setMungBean(_this, param, listener)
    },
    hideDialog () {
      this.dialogMungBeanFormVisible = false
    }
  }
}

</script>
